import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { labKeys } from '../queries/keys';
import { labPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for labs (api-reference/admin-labs.md).

export function useLabsList(filters) {
    return useQuery({
        queryKey: labKeys.list(filters),
        queryFn:  ({ signal }) => api.get(labPaths.list(), { params: filters, signal }).then(r => r.data),
        placeholderData: (prev) => prev,
    });
}

export function useLab(id) {
    return useQuery({
        queryKey: labKeys.detail(id),
        queryFn:  ({ signal }) => api.get(labPaths.detail(id), { signal }).then(r => r.data),
        enabled:  !!id && id !== 'new',
    });
}

export function useCreateLab() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(labPaths.list(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: labKeys.all }),
    });
}

export function useUpdateLab(id) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.patch(labPaths.detail(id), payload).then(r => r.data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: labKeys.detail(id) });
            qc.invalidateQueries({ queryKey: labKeys.all });
        },
    });
}

export function useDeleteLab() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(labPaths.detail(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: labKeys.all }),
    });
}
